'use client'
import {
  ImageCard,
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'

import {
  AlignmentType,
  ImageCardProps,
  NormalizedSection,
  OpeningTitleProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

export interface VideoProps extends NormalizedSection {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    paragraph: ParagraphProps
    imageCard: ImageCardProps
  }
  props?: {
    alignment?: AlignmentType
  }
}

function Video({ modelledContent, props }: VideoProps) {
  const { openingTitle, title, paragraph, imageCard } = modelledContent
  const { alignment } = props || {
    alignment: 'left',
  }

  const alignmentCssVariant = `${alignment}`
  const openingTitleLabel = openingTitle?.content
  const titleLabel = title?.content
  const paragraphContent = paragraph?.content

  return (
    <Section className={`section-video ${alignmentCssVariant}`}>
      <div className='section-video__content-wrapper'>
        <div className='section-video__content-wrapper__title-wrapper'>
          {openingTitleLabel ? (
            <OpeningTitle
              className={`section-video__content-wrapper__title-wrapper__opening-title`}
              {...openingTitle}
            >
              {openingTitleLabel}
            </OpeningTitle>
          ) : null}

          {titleLabel ? (
            <Title
              className={`section-video__content-wrapper__title-wrapper__title`}
              {...title}
            >
              {titleLabel}
            </Title>
          ) : null}
        </div>
        {paragraphContent ? (
          <Paragraph
            as={'div'}
            className={`section-video__content-wrapper__paragraph`}
            {...paragraph}
            dangerouslySetInnerHTML={{ __html: paragraphContent }}
          />
        ) : null}
      </div>
      {imageCard && imageCard.title ? (
        <ImageCard
          className={`section-video__image-card`}
          title={imageCard.title}
          body={imageCard.body}
          cta={imageCard.cta}
          image={imageCard.image}
        />
      ) : null}
    </Section>
  )
}

export default Video
